import dictionary from "../dictionary";
import UserDictionary from "../dictionary/UserDictionary";
import methods from "../methods";

const { auth } = dictionary;
const { get, post, patch, put, deleteData } = methods;

const AuthService = {
  propertyLoginService: (body) => {
    return post(auth.propertyLogin(), body);
  },
  mainPropertyLoginService: (body) => {
    return post(auth.mainPropertyLogin(), body);
  },
  userLogin: (body) => {
    return post(auth.userLogin(), body);
  },
  userVerify: (body) => {
    return post(auth.userVerify(), body);
  },
  updateUser: (body) => {
    return put(auth.editUser(body.id), body.data);
  },
  getUserDetails: (id) => {
    return get(auth.getUserUrl(id));
  },
  getPropetyUserData: (id) => {
    return get(auth.getPropetyUser(id));
  },
  getAllRoles: () => {
    return get(auth.getRoles());
  },
  createRole: (data) => {
    return post(auth.getRoles(), data);
  },
  updateRole: (id, data) => {
    return put(auth.getRoles() + "/" + id, data);
  },
  deleteRole: (id) => {
    return deleteData(auth.getRoles() + "/" + id);
  },
  deleteRroomsUser: (id) => {
    return deleteData(UserDictionary.delRroomsUsers(id));
  },
  deletePrtUser: (id) => {
    return deleteData(UserDictionary.delPropertyUsers(id));
  },
  getAllRroomsUser: (id) => {
    return get(auth.getRoomsUser());
  },
  getAppService: (data) => {
    return post(auth.getApp(), data);
  },
  getOwnerProperties: (data)=>{
    return post(auth.ownerProperties(), data)
  },
  rroomUserChangePasswordService: (id, data)=>{
    return post(auth.rroomUserChangePassword(id), data)
  },
  propertyUserChangePasswordService: (id, data)=>{
    return post(auth.propertyUserChangePassword(id), data)
  },

  rroomUserForgotPasswordService: (data)=>{
    return post(auth.rroomUserForgotPassword(), data)
  },
  propertyUserForgotPasswordService: (data)=>{
    return post(auth.propertyUserForgotPassword(), data)
  },

  generateOtpForPropertyUser: (body) => {
    return post(auth.generatePropertyUserOtp(), body);
  },
  loginWithOtpForPropertyUser: (body) => {
    return post(auth.loginPropertyUserWithOtp(), body);
  },
};

export default AuthService;
